import { createClaimRequest } from './helper';
export const getClaimData = createClaimRequest({
    route: '/claim/claimData/:claimNumber',
    method: 'get',
    source: 'data',
});
